import React, { useState, useEffect } from "react";
import { Box, Grid, Typography, CircularProgress, Card, CardContent, Button } from "@mui/material";
import { useHistory } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import ShareIcon from "@mui/icons-material/Share";
import BottomNav from "../../components/Bottom nav/BottomNav";
import useCommonQuery from "../../store/common/useCommonQuery";
import noPic from "../../assets/no-pic.png";
import "./ArivumAarogyavum.css";

const PAGE_SIZE = 200;

const ArivumAarogyavum = () => {
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);

  const { data: extraSubCategories, isLoading: isLoadingSubCategories } = useCommonQuery.Get_extra_subcategories({
    search: "",
    limit: PAGE_SIZE,
    offset: (currentPage - 1) * PAGE_SIZE,
  });

  const results = extraSubCategories?.data?.results || [];
  const totalCount = extraSubCategories?.data?.count || results.length;
  const totalPages = Math.ceil(totalCount / PAGE_SIZE);

  const handleSubCategoryClick = (subCategory) => {
    // Store subcategory data for products page
    localStorage.setItem('selectedSubCategory', subCategory.id);
    localStorage.setItem('selectedSubCategoryName', subCategory.name);
    
    // Navigate to products page
    history.push('/arivum-aarogyavum/products');
  };

  
  return (
    <div>
      {/* Header bar */}
      <div className="arivum-header">
        <div className="arivum-header-inner">
          {/* Home button — crystal glass square, matches Recognition/Influencers ip-nav-btn */}
          <button className="arivum-nav-btn" onClick={() => history.push('/')} aria-label="Home">
            <div className="arivum-nav-btn-glow" />
            <HomeIcon style={{ fontSize: 15, color: "#fff", position: "relative", zIndex: 1 }} />
          </button>

          <Typography style={{ color: "#333", fontSize: "18px", fontWeight: "600" }}>
            STUDY MASTER
          </Typography>

          {/* Share button — crystal glass square, matching pair */}
          <button className="arivum-nav-btn" onClick={() => {
            if (navigator.share) {
              navigator.share({
                title: 'STUDY MASTER',
                text: 'STUDY MASTER - Knowledge and Health',
                url: window.location.href
              });
            }
          }} aria-label="Share">
            <div className="arivum-nav-btn-glow" />
            <ShareIcon style={{ fontSize: 15, color: "#fff", position: "relative", zIndex: 1 }} />
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="arivum-container">
        <div className="arivum-content-wrapper">
          {isLoadingSubCategories ? (
            <Box sx={{ display: "flex", justifyContent: "center", padding: "40px" }}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              <div className="arivum-grid">
                {results.map((item) => (
                  <div
                    key={item.id}
                    className="arivum-item-card"
                    onClick={() => handleSubCategoryClick(item)}
                  >
                    <div className="arivum-image-wrapper">
                      <img
                        src={item.image || noPic}
                        alt={item.name}
                        className="arivum-image"
                      />
                      <div className="arivum-image-shadow"></div>
                    </div>
                    <div className="arivum-label-wrapper">
                      <Typography className="arivum-label">
                        {item.name}
                      </Typography>
                    </div>
                  </div>
                ))}
              </div>
              
              {/* Pagination */}
              {totalPages > 1 && (
                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'flex-end', 
                  alignItems: 'center', 
                  mt: 3, 
                  mb: 2,
                  px: 2
                }}>
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(p => p - 1)}
                    sx={{ mr: 2, minWidth: 80 }}
                  >
                    Previous
                  </Button>
                  <Typography variant="body2" sx={{ mx: 2, color: '#666' }}>
                    Page {currentPage} of {totalPages}
                    <Typography component="span" sx={{ ml: 1, fontSize: '0.85em', color: '#999' }}>
                      ({totalCount} total)
                    </Typography>
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={currentPage >= totalPages}
                    onClick={() => setCurrentPage(p => p + 1)}
                    sx={{ ml: 2, minWidth: 80 }}
                  >
                    Next
                  </Button>
                </Box>
              )}
            </>
          )}
        </div>
      </div>
      <BottomNav />
    </div>
  );
};

export default ArivumAarogyavum;
